// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"postContainer--IxA8k","submitButton":"submitButton--E4vVT"};